// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.button-icon[data-v-0178aae2]{\r\n\tposition: absolute;\r\n\tright: 5px;\r\n\ttop: 10px;\n}\n.text[data-v-0178aae2]{\r\n\tpadding-left: 10px;\r\n\tpadding-right: 10px;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
